<template>
  <!--back-to-top start-->
        <a id="totop" href="#top">
            <i class="fa fa-angle-up"></i>
        </a>
        <!--back-to-top end-->
</template>

<script>
export default {
  name: "BackToTop",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>




